var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrown = function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB31B",
    d: "M15.373 17.398H6.628a.92.92 0 0 1-.862-.605L1.953 6.114c-.303-.852.669-1.576 1.393-1.054l3.667 2.622a.923.923 0 0 0 1.393-.422l1.733-4.62c.293-.797 1.42-.797 1.714 0l1.732 4.62c.211.568.899.77 1.394.422l3.666-2.622c.734-.522 1.696.211 1.394 1.054l-3.814 10.68a.9.9 0 0 1-.852.604",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB31B",
    d: "M15.583 20.167H6.417a.69.69 0 0 1-.688-.688c0-.376.312-.687.688-.687h9.166c.376 0 .688.311.688.687a.69.69 0 0 1-.688.688M13.292 13.52H8.709a.693.693 0 0 1-.688-.687c0-.376.312-.687.688-.687h4.583c.376 0 .687.311.687.687a.69.69 0 0 1-.687.688"
  })));
};
export default SvgCrown;